import React from "react";

import MyAccountPage from "@/components/user/MyAccountPage";
import NotFound from "@/components/common/NotFound";
import { isProspect } from "@/utils/type";

const MyAccount = ({ type }) => {
    return isProspect(type) ? <MyAccountPage /> : <NotFound />;
};

export async function getStaticProps() {
    return { props: { type: process.env.NEXT_PUBLIC_TYPE } };
}

export default MyAccount;
